import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const GET_VIDEO_URL_SCHEMA = z.object({
  url: z.string().url(),
});

export const getVideoUrlPromise = async (taskId: string) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    const res = await ky
      .get(`${ENV.API_URL}/reingestor/task/${taskId}/video`, {
        headers,
      })
      .json();

    const result = GET_VIDEO_URL_SCHEMA.safeParse(res);

    if (!result.success) {
      console.error(result.error);
      return null;
    }

    const url = result.data?.url;

    return url;
  } catch (error) {
    console.error('Error fetching video url:', error);
    return null;
  }
};
